@if (isUserMessage()) {
  <bevvi-user-chat-bubble [message]="userMessage()!.text" />
} @else {
  <div class="flex flex-col gap-3">
    @for (payload of botMessage()!.payload; track $index) {
      <bevvi-payload-renderer
        [payload]="payload"
        [disabled]="isDisabled()"
        (userReply)="onUserReply($event)"
      />
    }
  </div>
}
